import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import {
  getBucketPreferencesRequestFailed,
  getBucketPreferencesRequestSucceeded,
  getBucketPreferencesRequested,
} from 'redux/slice/settings/Preferences/BucketPreference.slice';
import { IGetPreferencePayload } from 'redux/types/Preference.types';
import { IError } from 'redux/types/UserOnboardDetails.types';
import { settingsEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* getBucketPreferenceSaga({
  payload,
}: PayloadAction<IGetPreferencePayload>) {
  try {
    const { offset, limit, searchCriteria } = payload;
    const response: AxiosResponse<any> = yield HTTPClient.GetRequest(
      settingsEndpoints.GET_PREFERENCES(
        'buckets',
        offset,
        limit,
        searchCriteria
      )
    );

    yield put(getBucketPreferencesRequestSucceeded(response.data.data));
  } catch (err) {
    yield put(
      getBucketPreferencesRequestFailed({
        error: 'Error while fetching bucket preferences',
      } as IError)
    );
  }
}

export function* watchGetBucketPreferenceSaga() {
  yield takeLatest(getBucketPreferencesRequested.type, getBucketPreferenceSaga);
}
